<template>
  <BaseCustomizeMetal componentCode="D" />
</template>
<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalD",
  components: {
    BaseCustomizeMetal,
  },
};
</script>
<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 82px;
    left: 185px;
    @include betweenTableTablePro {
      top: 50px;
      left: 135px;
    }
    @include table {
      top: 33px;
      left: 111px;
    }
    @include phone {
      top: 23px;
      left: 96px;
    }
  }
  .templeName {
    height: 33px;
    width: 119px;
    .textContainer {
      width: 119px;
    }
  }
  .godName {
    width: 129px;
    height: 75px;
    .textContainer {
      width: 129px;
    }
  }
  .gift {
    margin: 0 0 auto auto;
    width: 129px;
    height: 35px;
    .textContainer {
      width: 129px;
    }
  }
}
</style>
